import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { BetBarComponent } from "slotworks/components/betbar/bet-bar-component";
import { FreespinRecord } from "slotworks/model/gameplay/records/freespin-record";
import { FreespinWinResult } from "slotworks/model/gameplay/records/results/freespin-win-result";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";

export function TGRUpdateFreespinsCountsInBetBar() {
    if (gameState.getCurrentGame().hasRecords()) {
        const rootRec: SpinRecord = gameState.getCurrentGame().getRootRecord() as SpinRecord;
        if (rootRec.hasChildren) {
            const fsPlayed: number = rootRec.currentChildIndex + 1;
            let fsAwarded: number = rootRec.getFirstResultOfType(FreespinWinResult).freespinsWon;
            for (let i: number = 0; i < rootRec.currentChildIndex; i++) {
                const fsRec: FreespinRecord = rootRec.children[i] as FreespinRecord;
                const fsWinResult: FreespinWinResult = fsRec.getFirstResultOfType(FreespinWinResult);
                if (fsWinResult) {
                    fsAwarded += fsWinResult.freespinsWon;
                }
            }

            Components.get(BetBarComponent).setTotalFreespins(fsAwarded);
            Components.get(BetBarComponent).setFreespinsPlayed(fsPlayed);
        }
    }
}
